import { useLayoutEffect, useState } from "react"
import agreeStyle from "./agree.module.css"

import QQQ from "./text"
import { useModal } from "modal/provider"


export default function Agree(props) {

    const { modal_open } = useModal()

    const set = props['set']
    const name = props['name']
    const required = props['required']
    const error = props['error']
    const scheduleInfo = props['scheduleInfo']

    const [value, Set_value] = useState('')
    const [view, Set_view] = useState(false)

    // useLayoutEffect(() => {
    //     const agree_content = document.getElementById(`agree_${set}_content`)
    //     if(view) {
    //         agree_content.style.height = "300px"
    //     }
    //     else {
    //         agree_content.style.height = "0px"
    //     }
    // }, [view])

    function sss() {
        modal_open({
            compnent: () => QQQ({
                scheduleInfo: scheduleInfo
            })
        })
    }

    function all_check(checked) {
        const agree_check = document.querySelectorAll('[agree_check="1"]')
        const agree_value = document.querySelectorAll('[agree_value="1"]')
        for(let i=0; i<agree_check.length; i++) {
            agree_check[i].checked = checked
        }
        for(let i=0; i<agree_value.length; i++) {
            if(checked) {
                agree_value[i].value = '1'
            }
            else {
                agree_value[i].value = null
            }
        }
    }

    function one_check(checked) {
        const agree_all_check = document.querySelector('[agree_all_check="1"]')
        if(checked) {
            document.querySelector(`[name="${name}"]`).value = '1'

            const agree_check = document.querySelector('[agree_check="1"]:not(:checked)')
            if(agree_check === null) {
                agree_all_check.checked = true
            }
        }
        else {
            document.querySelector(`[name="${name}"]`).value = ''

            agree_all_check.checked = false
        }
    }

    return(
        <>
            <div className={agreeStyle['agreeWrap']}>
                <input
                    type="text"
                    category="field"
                    name={name}
                    required={required === true ? true : false}
                    style={{
                        display: "none"
                    }}
                    readOnly={true}
                    error={error}
                    agree_value="1"
                ></input>

                <label className={agreeStyle['agree']}>
                    <input
                        type="checkbox"
                        name={`agree_${set}`}
                        required={required === true ? true : false}
                        onClick={(e) => one_check(e.currentTarget.checked)}
                        agree_check="1"
                    ></input>
                    <div className={agreeStyle['checkbox']}>
                        <div className={agreeStyle['mark']}></div>
                    </div>
                    {set === 'person' &&
                    <>
                        <div className={agreeStyle['sub']}>[필수]</div>
                        <div className={agreeStyle['text']}>개인정보 수집·이용에 대한 동의</div>
                    </>
                    }
                    {set === 'agent' &&
                    <>
                        <div className={agreeStyle['sub']}>[필수]</div>
                        <div className={agreeStyle['text']}>만 14세 미만 아동 학생 개인정보 수집·이용에 대한 법정 대리인 동의</div>
                    </>
                    }
                    {set === 'promotion' &&
                    <>
                        <div className={agreeStyle['sub']}>[선택]</div>
                        <div className={agreeStyle['text']}><span style={{color: "blue"}}>교육 설명회 등 정보 전달을 위한 </span>개인정보 마케팅 및 광고 활용 동의</div>
                    </>
                    }
                    {set === 'period' &&
                    <>
                        <div className={agreeStyle['sub']}>[선택]</div>
                        <div className={agreeStyle['text']}><span style={{color: "blue"}}>퇴원 후 교육 설명회 등 정보 전달을 위한 </span>개인정보 보유기간에 관한 추가 동의</div>
                    </>
                    }
                </label>

                {/* <div
                    className={agreeStyle['viewButton']}
                    onClick={() => Set_view(!view)}
                >{view ? '닫기' : '보기'}</div> */}
                <div
                    style={{
                        flexShrink: 0,
                        fontSize: "14px",
                        fontWeight: "bold",
                        cursor: "pointer"
                    }}
                    onClick={() => sss()}
                >보기</div>
            </div>

            {set === 'period' &&
                <div className={agreeStyle['agreeWrap']}>
                    <label className={agreeStyle['agree']}>
                        <input
                            type="checkbox"
                            agree_all_check="1"
                            onClick={(e) => all_check(e.currentTarget.checked)}
                        ></input>
                        <div className={agreeStyle['checkbox']}>
                            <div className={agreeStyle['mark']}></div>
                        </div>
                        <div className={agreeStyle['text']} style={{marginInline: "5px"}}>모두 동의</div>
                    </label>
                </div>
            }

            {/* <div
                id={`agree_${set}_content`}
                className={agreeStyle['content']}
            >
                {set === 'person' &&
                    <Person></Person>
                }
                {set === 'transfer' &&
                    <Transfer></Transfer>
                }
                {set === 'promotion' &&
                    <Promotion></Promotion>
                }
            </div> */}
        </>
    )
}